module.exports = __webpack_public_path__ + "img/20220219_071928.e423c8fe.jpg";